import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, Grid } from '@mui/material';

import * as ENDPOINT from 'config/endpoint';
import { turnOffEvent } from 'utils/helpers';
import { appStoreMakeRequest } from 'reactStore/slices/appStoreSlice';
import MGrid from 'components/MaterialUI/MGrid';
import MText from 'components/MaterialUI/MText';
import MPopover from 'components/MaterialUI/MPopover';

const CancelHotelPopover = (props) => {
  const { onClose, anchorEl, freeCancellationBefore, orderItemId } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClose = () => {
    onClose(null);
  };

  const handleConfirm = (e) => {
    turnOffEvent(e);
    const dataSource = `${ENDPOINT.REFUND_REQUESTS}`;
    const data = { data: { order_item_id: orderItemId, ['refund_type']: 'voluntary' } };
    dispatch(appStoreMakeRequest({ dataSource, data, method: 'POST' }));
    handleClose();
    onClose('voluntary');
  };

  return (
    anchorEl !== 'voluntary' && (
      <MPopover {...{ anchorEl }} onClose={handleClose}>
        <Grid container spacing={2} direction="column">
          <Grid item children={<MText align="center" variant="h3" children={t('Actions.ArrangeRefund')} />} />
          <MGrid size={12} spacing={1} justifyContent="flex-start">
            <Grid item>
              <MText variant="subtitle1" weight="bold" children={t('Orders.HotelRefundAgreement')} />
            </Grid>
            <Grid item>
              <MText
                variant="subtitle1"
                children={`Бесплатная отмена до: ${moment(freeCancellationBefore).format('LLL')}`}
              />
            </Grid>
          </MGrid>
          <MGrid size={12} spacing={1}>
            <Grid item>
              <Button size="small" variant="outlined" onClick={handleClose} children={t('Actions.Cancel')} />
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                onClick={handleConfirm}
                children={t('Actions.Continue')}
              />
            </Grid>
          </MGrid>
        </Grid>
      </MPopover>
    )
  );
};

CancelHotelPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  orderItemId: PropTypes.string,
  freeCancellationBefore: PropTypes.string,
};

export default CancelHotelPopover;
